export type SpriteName =
  | "pup_down" | "pup_side" | "pup_up"
  | "scorpion" | "spider" | "snake" | "bat" | "bat_rest"
  | "bg_1" | "bg_2" | "bg_3" | "bg_4" | "bg_5" | "bg_6"
  | "bone_ball" | "bonus_burst"
  | "power_freeze" | "power_ghost";

export type Sprites = Partial<Record<SpriteName, HTMLImageElement>>;

const NAMES: SpriteName[] = ["pup_down", "pup_side", "pup_up", "scorpion", "spider", "snake", "bat", "bat_rest", "bg_1", "bg_2", "bg_3", "bg_4", "bg_5", "bg_6", "bone_ball", "bonus_burst", "power_freeze", "power_ghost"];

export type Skin = "red" | "blue" | "green" | "purple" | "gold";
export const SKINS: { id: Skin; stars: number; color: string }[] = [
  { id: "red", stars: 0, color: "#dc2626" },
  { id: "blue", stars: 8, color: "#2563eb" },
  { id: "green", stars: 20, color: "#16a34a" },
  { id: "purple", stars: 40, color: "#9333ea" },
  { id: "gold", stars: 70, color: "#eab308" },
];
export const pupSprite = (skin: Skin, base: "pup_down" | "pup_side" | "pup_up") => (skin === "red" ? `/sprites/${base}.png` : `/sprites/${base}_${skin}.png`);

const cache = new Map<string, HTMLImageElement>();
const getImg = (src: string) => {
  let img = cache.get(src);
  if (!img) { img = new Image(); img.src = src; cache.set(src, img); }
  return img;
};

export function loadSprites(onReady: (s: Sprites) => void, skin: Skin = "red"): Sprites {
  const sprites: Sprites = {};
  NAMES.forEach((name) => {
    const img = getImg(name.startsWith("pup_") ? pupSprite(skin, name as "pup_down" | "pup_side" | "pup_up") : `/sprites/${name}.png`);
    if (img.complete && img.naturalWidth > 0) sprites[name] = img;
    else img.addEventListener("load", () => { sprites[name] = img; onReady(sprites); }, { once: true });
  });
  return sprites;
}

export const preloadSprites = (skin: Skin) => { loadSprites(() => {}, skin); };
